import React from "react";
import { useMatch, useNavigate } from "react-router";
import MultiScreenContainer from "../pages/MultiScreen/MultiScreenContainer/MultiScreenContainer";
import { AppContext } from "./ApplicationContextProvider";
import type { AppContextType } from "./types";

const CampaignSelector: React.FC = () => {
  const { details } = React.useContext(AppContext) as AppContextType;
  const match = useMatch("/:businessLine/token/:token/:campaign/complete");
  const businessLine = match?.params?.["businessLine"];
  const token = match?.params?.["token"];
  const campaign = match?.params?.["campaign"];
  const navigate = useNavigate();

  if (!details?.campaignDetails || !campaign || !businessLine || !token) {
    return null;
  }

  if (campaign.toLowerCase() !== details.campaignDetails.name.toLowerCase()) {
    navigate(
      `/${businessLine}/token/${token}/${details.campaignDetails.name}/complete`,
      { replace: true }
    );
    return null;
  }

  switch (details.campaignDetails.type) {
    case "dataCollection":
    case "documentPresenter":
      return <MultiScreenContainer />;
    default:
      return null;
  }
};

export default CampaignSelector;
